import { Dropdown } from "antd";
import { useState } from "react";
import { useDispatch } from "react-redux";
import ToolbarButtonComponent from "../../../components/button_toolbar/toolbar_button.component";
import { custominfo } from "../../../components/icon_notification/customNotifications";
import { exportSelectedProperties } from "../../../redux/Immobilier/properties/prop.api";
import { formatForExport } from "../../../redux/Immobilier/properties/prop.util";
import "./exportModal.scss";

const EXPORTS = {
    SE_LOGER: "SeLoger",
    OCTISSIMO: "Octissimo",
    LE_BON_COIN: "LeBonCoin",
};

const ExportModal = ({ selectedProperties = [] }) => {
    const dispatch = useDispatch();
    const [showExportModal, setShowExportModal] = useState(false);

    const exportToSeLoger = () => {
        exportSelectedPropertiesToAPI(EXPORTS.SE_LOGER)
    }
    const exportToOctissimo = () => {
        exportSelectedPropertiesToAPI(EXPORTS.OCTISSIMO)
    }
    const exportToLeBonCoin = () => {
        exportSelectedPropertiesToAPI(EXPORTS.LE_BON_COIN)
    }

    const exportSelectedPropertiesToAPI = (exportType) => {
        if (selectedProperties.length) {
            dispatch(exportSelectedProperties({ ...formatForExport(selectedProperties), exportApp: exportType }))
        }
    }

    const openDropdown = () => {
        if (selectedProperties.length) {
            setShowExportModal(true)
        } else {
            custominfo("Sélection vide", "Veuillez sélectionner des propriétés à exporter")
        }
    }

    return (
        <Dropdown
            menu={{
                items: [
                    {
                        label: <p className="m-0 fw-bold">Exporter la sélection vers</p>,
                    },
                    {
                        key: 1,
                        label: <ToolbarButtonComponent
                            className="k-button-outline-secondary w-100"
                            onclick={exportToSeLoger}
                            text={"Se Loger"}
                        />
                    },
                    {
                        key: 2,
                        label: <ToolbarButtonComponent
                            className="k-button-outline-secondary w-100"
                            onclick={exportToOctissimo}
                            text={"Octissimo"}
                        />
                    },
                    {
                        key: 3,
                        label: <ToolbarButtonComponent
                            className="k-button-outline-secondary w-100"
                            onclick={exportToLeBonCoin}
                            text={"Le Bon Coin"}
                        />
                    }],
            }}
            onOpenChange={() => setShowExportModal(false)}
            open={showExportModal}
            trigger={["click"]}
        >
            <ToolbarButtonComponent
                icon="upload"
                title="Exporter la sélection"
                id="lbc-export-btn"
                onclick={openDropdown}
            />
        </Dropdown>
    )
}

export default ExportModal;